import { render, staticRenderFns } from "./template.vue?vue&type=template&id=72405f5d&scoped=true&"
import script from "@/Components/Global/MenuBar/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Global/MenuBar/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Global/MenuBar/style.scss?vue&type=style&index=0&id=72405f5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72405f5d",
  null
  
)

export default component.exports